import { NgModule } from "@angular/core";
import { ContractsViewComponent, FileViewerComponent } from "./contracts-view.component";
import { CommonModule } from "@angular/common";
import { ContractsRoutingModule } from "../contracts.routing";
import { SharedModule } from "src/app/modules/shared.module";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { EquipmentsViewComponent } from "../equipments-view/equipments-view.component";
import { FormsModule } from "@angular/forms";
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { HistoryDialogComponent } from "../history-dialog/history-dialog.component";

@NgModule({
    declarations: [ContractsViewComponent, FileViewerComponent, EquipmentsViewComponent, HistoryDialogComponent],
    imports: [ CommonModule, SharedModule, MatTableModule, MatPaginatorModule, FormsModule, MatSlideToggleModule ],
    exports: [ ContractsViewComponent, ContractsRoutingModule ],
    providers: []
})
export class ContractsViewModule {}